import {HttpService} from "./HttpService";
import {AxiosResponse} from "axios";

export class OperatorsHttpService {

    static URL_OPERATORS_FILE_UPLOAD_PREVIEW = "/admin/operators/previewUploadFile"
    static URL_OPERATORS_SAVE_ALL = "/admin/operators/saveAll"
    static URL_OPERATORS_EXPORT = "/admin/operators/export"


    static async uploadPracticeFiles(formData:FormData):Promise<AxiosResponse<any, any>>{
        return await HttpService.getLuxotticaAxios().post<any>(this.URL_OPERATORS_FILE_UPLOAD_PREVIEW, formData)
    }
    static async saveAllPracticeFiles(formData:FormData):Promise<AxiosResponse<any, any>>{
        return await HttpService.getLuxotticaAxios().post<any>(this.URL_OPERATORS_SAVE_ALL, formData)
    }

    static async exportAllOperators():Promise<AxiosResponse<any, any>>{
        return await HttpService.getLuxotticaAxios().get<any>(this.URL_OPERATORS_EXPORT, {responseType: 'blob'})
    }
}
